<template>
  <div class="LorRbg">
    <div class="w1000 clearfix">
      <div class="LorRright">
        <el-tabs v-model="activeName" @tab-click="handleClick" class="tabcon1">
          <el-tab-pane label="密码登录" name="first">
            <el-form ref="loginForm" :model="loginForm" :rules="loginRules">
              <el-form-item prop="mobilePhone">
                <i class="icon icon1"></i>
                <el-input v-model="loginForm.mobilePhone" placeholder="手机号"></el-input>
              </el-form-item>
              <el-form-item prop="passWord">
                <i class="icon icon2"></i>
                <el-input v-model="loginForm.passWord" placeholder="密码" type="password"></el-input>
              </el-form-item>
              <el-form-item class="codeimg" prop="verCode">
                <i class="icon icon3"></i>
                <el-input v-model="loginForm.verCode" placeholder="验证码"></el-input>
                <img :src="picCode" alt="" @click="getPicCode">
              </el-form-item>
              <a class="lorbtn" :class="{ active: allinput}" @click="loginfun">立即登录</a>
              <div class="descbox" v-if="descFlag">琼中县图书馆读者账号登录</div>
              <div class="funbox clearfix">
                <a class="fl" @click="register">马上注册 → </a>
                <a class="fr" @click="forget">忘记密码?</a>
              </div>
            </el-form>
          </el-tab-pane>
          <el-tab-pane label="快捷登录" name="second">
            <el-form ref="loginForm1" :model="loginForm1" :rules="loginRules1">
              <el-form-item prop="mobilePhone">
                <i class="icon icon1"></i>
                <el-input v-model="loginForm1.phone" placeholder="手机号"></el-input>
              </el-form-item>
              <el-form-item class="verification" prop="verCode">
                <i class="icon icon3"></i>
                <el-input v-model="loginForm1.verCode" placeholder="验证码"></el-input>
                <p class="code" v-show="verShow" @click="getauthcode">获取验证码</p>
                <p class="code gray" v-show="!verShow">重新发送<i>{{timer}}</i>s</p>
              </el-form-item>
              <a class="lorbtn" :class="{ active: allinput1}" @click="loginfun1">立即登录</a>
              <div class="descbox" v-if="descFlag">琼中县图书馆读者账号登录</div>
              <div class="funbox clearfix">
                <a class="fl" @click="register">马上注册 → </a>
                <a class="fr" @click="forget">忘记密码?</a>
              </div>
            </el-form>
          </el-tab-pane>
          <!--<el-tab-pane label="扫码登录" name="second" v-if="scancodeFlag">-->
            <!--<div class="codebox">-->
              <!--<div class="imgbox">-->
                <!--<img src="../../assets/common/images/ewm.png" alt="">-->
              <!--</div>-->
              <!--<div class="descbox"><p>打开<em>学习通</em></p><p>扫一扫登录</p></div>-->
            <!--</div>-->
          <!--</el-tab-pane>-->
        </el-tabs>
      </div>
      <div class="LorRleft">
        <div class="codebox" v-if="codeFlag">
          <div class="imgbox">
            <img :src="downloadImg" alt="">
          </div>
          <p>{{ downloadtext }}</p>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
// loginToken,
import { getVERCode, IsRegister, phoneQuicklogin, loginTokenEnc } from '@/api/user/index'
export default {
  name: 'login',
  meta: {
    showHeader: true
  },
  data () {
    let checkPhone = (rule, value, callback) => {
      if (!value) {
        return callback(new Error('手机号不能为空'))
      } else {
        if (value.length === 11) {
          callback()
        } else {
          return callback(new Error('请输入11位'))
        }
      }
    }
    return {
      /* tab选项卡默认值 */
      activeName: 'first',
      /* 扫码登录控制 */
      scancodeFlag: true,
      /* 二维码控制 */
      codeFlag: true,
      /* 登录描述控制 */
      descFlag: false,
      loginForm: {
        mobilePhone: '',
        passWord: '',
        verCode: ''
      },
      loginRules: {
        mobilePhone: [{required: true, message: '请输入正确的手机号', validator: checkPhone, trigger: 'blur'}],
        passWord: [{required: true, message: '密码不能为空', trigger: 'blur'}],
        verCode: [{required: true, message: '请输入验证码', trigger: 'blur'}]
      },
      picCode: '',
      timers: null,
      allinput: false,
      timer: 60,
      verShow: true,
      loginForm1: {
        phone: '',
        verCode: '',
        fid: this.$cookie.get('culturalCloud_fid')
      },
      loginRules1: {
        phone: [{required: true, message: '请输入正确的手机号', validator: checkPhone, trigger: 'blur'}],
        verCode: [{required: true, message: '请输入验证码', trigger: 'blur'}]
      },
      allinput1: false,
      existParam: {
        phone: '',
        fid: this.$cookie.get('culturalCloud_fid')
      },
      List: [],
      unitName: '',
      downloadImg: require('@/assets/common/images/ewm.png'),
      downloadtext: '下载学习通'
    }
  },
  watch: {
    'loginForm.mobilePhone' (val) {
      if (val && val.length === 11) {
        this.getPicCode()
      }
    },
    'loginForm.verCode' (val) {
      if (val) {
        this.allinput = true
      }
    },
    'loginForm1.phone' (val) {
      if (val && val.length === 11) {
        this.existParam.phone = val
        this.getIsRegister()
      }
    },
    'loginForm1.verCode' (val) {
      if (val) {
        this.allinput1 = true
      }
    },
    adSlot (val) {
      if (val) {
        this.List = val
        this.getData()
      }
    }
  },
  computed: {
    adSlot () {
      return this.$store.state.adSlot.list
    }
  },
  mounted () {
    this.getPicCode()
    if (this.$store.state.adSlot.list.length !== 0) {
      this.List = this.$store.state.adSlot.list
      this.getData()
    }
  },
  methods: {
    getData () {
      this.List.forEach(item => {
        if (item.slotCode === 'messagename') {
          this.unitName = item.slotName
        }
        if (item.slotCode === 'downloadconfig') {
          this.downloadtext = item.slotName
          if (item.imgPath !== undefined && item.imgPath !== '') {
            this.downloadImg = item.imgPath
          }
        }
      })
    },
    getPicCode () {
      this.picCode = process.env.BASE_API + '/api/auth/jwt/getCode?' + new Date().getTime() + '&phone=' + this.loginForm.mobilePhone
    },
    handleClick () {
    },
    register () {
      this.$router.push({path: '/register', query: { redirect: this.$route.query.redirect }})
    },
    forget () {
      this.$router.push({path: '/forget', query: { redirect: this.$route.query.redirect }})
    },
    /* 用户是否已经注册过 */
    getIsRegister () {
      IsRegister(this.existParam).then(res => {
        // console.log(res)
        if (!res.data.rel) {
          this.$message({message: res.data.message, type: 'warning'})
        }
      })
    },
    getauthcode () {
      if (this.loginForm1.phone !== '') {
        this.verShow = false
        let authtimer = setInterval(() => {
          this.timer--
          if (this.timer <= 0) {
            this.verShow = true
            this.timer = 60
            clearInterval(authtimer)
          }
        }, 1000)
        const obj = {'status': 3, 'unitName': this.unitName}
        getVERCode(this.loginForm1.phone, obj).then((res) => {
          if (res.data.rel) {
            this.$message({message: res.data.data, type: 'success'})
          } else {
            this.$message.error(res.data.message)
          }
        })
      } else {
        this.$message({message: '请填写手机号', type: 'warning'})
      }
    },
    loginfun () {
      let _this = this
      this.$refs['loginForm'].validate((valid) => {
        if (valid) {
          loginTokenEnc({
            'mobilePhone': this.loginForm.mobilePhone,
            'passWord': this.loginForm.passWord,
            'departmentCode': this.$cookie.get('museumCode'),
            'verCode': this.loginForm.verCode
          }).then((res) => {
            // console.log(res)
            // console.log('vc3:', res.headers)
            if (res.data.rel) {
              this.$cookie.set('token', res.data.data.token)
              this.$cookie.set('wlymobilephone', res.data.data.mobilePhone)
              this.$cookie.set('wlyuserimg', res.data.data.image)
              this.$cookie.set('wlyuserid', res.data.data.id)
              this.$cookie.set('wlyusername', res.data.data.name)
              // this.$cookie.set('UID', res.data.data.id, {domain: '.chaoxing.com'})
              this.$message({
                message: '登录成功',
                type: 'success',
                duration: 1500
              })
              if (this.$route.query.redirect) {
                if (this.$route.query.redirect.indexOf('http') > -1) {
                  this.timers = setTimeout(() => {
                    location.href = this.$route.query.redirect
                  }, 2000)
                } else {
                  this.timers = setInterval(() => {
                    this.$router.push({path: decodeURIComponent(this.$route.query.redirect)})
                    location.reload()
                  }, 2000)
                }
              } else {
                this.timers = setTimeout(() => {
                  location.href = location.host
                }, 2000)
              }
            } else {
              this.$message.error(res.data.data)
            }
          }).catch(() => {
            _this.getPicCode()
          })
        }
      })
    },
    loginfun1 () {
      this.$refs['loginForm1'].validate((valid) => {
        if (valid) {
          phoneQuicklogin(this.loginForm1).then((res) => {
            if (res.data.rel) {
              this.$cookie.set('token', res.data.data.token)
              this.$cookie.set('wlymobilephone', res.data.data.mobilePhone)
              this.$cookie.set('wlyuserimg', res.data.data.image)
              this.$cookie.set('wlyuserid', res.data.data.id)
              this.$cookie.set('wlyusername', res.data.data.name)
              // this.$cookie.set('UID', res.data.data.id, {domain: '.chaoxing.com'})
              this.$message({
                message: '登录成功',
                type: 'success',
                duration: 1500
              })
              if (this.$route.query.redirect) {
                if (this.$route.query.redirect.indexOf('http') > -1) {
                  this.timers = setTimeout(() => {
                    window.location.href = this.$route.query.redirect
                  }, 2000)
                } else {
                  this.timers = setInterval(() => {
                    this.$router.push({path: decodeURIComponent(this.$route.query.redirect)})
                  }, 2000)
                }
              } else {
                this.timers = setTimeout(() => {
                  window.location.href = location.host
                }, 2000)
              }
            } else {
              this.$message.error(res.data.data)
            }
          }).catch(() => {
          })
        }
      })
    }
  },
  beforeDestroy () {
    clearInterval(this.timers)
    this.timers = null
    clearInterval(this.timer)
    this.timer = null
  }
}
</script>

<style lang="scss" scoped>
@import "../../assets/common/scss/_user.scss";
input::-webkit-input-placeholder {
  /* WebKit browsers */
  color: rgb(153, 153, 153);
}
input:-moz-placeholder {
  /* Mozilla Firefox 4 to 18 */
  color: rgb(153, 153, 153);
}
input::-moz-placeholder {
  /* Mozilla Firefox 19+ */
  color: rgb(153, 153, 153);
}
input:-ms-input-placeholder {
  /* Internet Explorer 10+ */
  color: rgb(153, 153, 153);
}
</style>



// WEBPACK FOOTER //
// src/view/user/login.vue